import { atom } from 'jotai'

const previewAtom = atom({
  isModalOpen: false,
  id: '',
  label: '',
  link: ''
})

export default previewAtom